import { Typography, useTheme } from '@material-ui/core';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { getDocument } from '../../api/document';
import { ApiContext } from '../../contexts/ApiContext';
import { AuthContext } from '../../contexts/AuthContext';
import { DocumentBar } from '../Common/DocumentBar';
import { SnackbarAlert, useSnackBar } from '../Common/SnackBarContext';

export default function DocumentDown() {
  const theme = useTheme();
  const apiContext = useContext(ApiContext);
  const authContext = useContext(AuthContext);

  const baseDocUrl = process.env.REACT_APP_CLOUD_STORAGE_BASE_URL;
  const [doclink, setDoclink] = useState('');

  const snackBarHelper = useSnackBar();

  const getDocFunc = useCallback(async (token) => {
    try {
      const res = await getDocument(apiContext.axios, token);

      setDoclink(baseDocUrl + res.data.document_url);
    } catch (e) {
      snackBarHelper.openSnackBar('error', String(e));
    }
  }, []);

  useEffect(async () => {
    const token = authContext?.auth;
    await getDocFunc(token);
  }, [getDocument]);

  return (
    <>
      <Typography variant="h5" display="inline">
        Dokumen Hasil Layanan{' '}
      </Typography>
      <Typography display="inline">untuk</Typography>
      <Typography
        variant="h4"
        color={theme.palette.type === 'dark' ? 'secondary' : 'primary'}
      >
        {authContext?.auth}
      </Typography>
      <DocumentBar link={doclink} preprocess="cloudinary"></DocumentBar>
      <SnackbarAlert />
    </>
  );
}
